import { Component, inject } from '@angular/core';
import { DebugService } from '../../service/debug.service';
import { UserLoginService } from '../../service/user-login.service';

@Component({
  templateUrl: './shared-home.component.html',
  styleUrls: ['./shared-home.component.scss'],
  standalone: false,
})
export class SharedHomeComponent {
  public userService = inject(UserLoginService);
  public debug = inject(DebugService);
}
